import React, { Fragment } from 'react';
import ObjectValuePreview from './ObjectValuePreview';
import { InternalApiEntitySchemaField } from '../../../api-internal';
import ChildValue from './ChildValue';
import RemainingValuesMessage from './RemainingValuesMessage';
import './ComplexValue.scss';

interface Props {
  fieldName: string;
  childAttributesAsString: string;
  parentSchemaFields?: InternalApiEntitySchemaField[];
  schemaFields?: InternalApiEntitySchemaField[];
  highlightedFields?: string[];
  isAmountOfValuesLimited?: boolean;
}

const ComplexValue = ({
  fieldName,
  childAttributesAsString,
  parentSchemaFields,
  schemaFields,
  highlightedFields,
  isAmountOfValuesLimited,
}: Props) => {
  let childAttributes;
  try {
    childAttributes = JSON.parse(childAttributesAsString);
  } catch (_) {
    return childAttributesAsString;
  }

  const parentSchemaField = parentSchemaFields?.find((schemaField) => schemaField.fieldName === fieldName);
  const childSchemaFields = schemaFields?.filter((schemaField) => schemaField.parentId === parentSchemaField?.id);

  const limitOfAmountOfValue = 3;
  const amountOfRemainingValues = Array.isArray(childAttributes)
    ? Math.max(childAttributes.length - limitOfAmountOfValue, 0)
    : 0;

  return (
    <div className='json-value-list'>
      {(Array.isArray(childAttributes) ? childAttributes : Array(childAttributes))
        .filter((childAttribute) => !!childAttribute)
        .slice(0, isAmountOfValuesLimited ? limitOfAmountOfValue : undefined)
        .map((childAttribute, index) =>
          typeof childAttribute === 'object' ? (
            Object.keys(childAttribute).length !== 0 ? (
              <ObjectValuePreview
                key={index}
                childAttributes={childAttribute}
                childSchemaFields={childSchemaFields}
                schemaFields={schemaFields}
                fieldAccessor={{
                  parentFieldName: fieldName,
                  attributeIndex: index,
                }}
                highlightedFields={highlightedFields}
              />
            ) : (
              <Fragment key={index} />
            )
          ) : (
            <div className='simple-arr-element' key={index}>
              <span>
                <ChildValue
                  value={childAttribute}
                  schemaFields={childSchemaFields}
                  fieldAccessor={{
                    parentFieldName: fieldName,
                    attributeIndex: index,
                    childFieldName: fieldName,
                  }}
                  highlightedFields={highlightedFields}
                />
              </span>
            </div>
          )
        )}
      {isAmountOfValuesLimited && <RemainingValuesMessage amountOfRemainingValues={amountOfRemainingValues} />}
    </div>
  );
};

export default ComplexValue;
